import { useEffect } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon-2x.png",
  iconUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon.png",
  shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png",
});

export const delivererIcon = (vehicle) => L.divIcon({
  className: "custom-marker",
  html: `<div style="background:${vehicle === "moto" ? "#10b981" : "#3b82f6"};width:36px;height:36px;border-radius:50%;display:flex;align-items:center;justify-content:center;border:3px solid white;box-shadow:0 2px 8px rgba(0,0,0,0.3);font-size:16px;color:white;">${vehicle === "moto" ? "&#x1F3CD;" : vehicle === "bicycle" ? "&#x1F6B4;" : "&#x1F697;"}</div>`,
  iconSize: [36, 36],
  iconAnchor: [18, 18],
});

export const restaurantIcon = L.divIcon({
  className: "custom-marker",
  html: `<div style="background:#ef4444;width:40px;height:40px;border-radius:50%;display:flex;align-items:center;justify-content:center;border:3px solid white;box-shadow:0 2px 8px rgba(0,0,0,0.3);font-size:18px;">&#x1F3EA;</div>`,
  iconSize: [40, 40],
  iconAnchor: [20, 20],
});

export function FitBounds({ positions }) {
  const map = useMap();
  useEffect(() => {
    if (positions.length > 0) {
      const bounds = L.latLngBounds(positions.map(p => [p.lat, p.lng]));
      map.fitBounds(bounds, { padding: [50, 50] });
    }
  }, [positions, map]);
  return null;
}
